module.exports = __webpack_public_path__ + "withSidebar-98c0f16c921438c91e80c750ecea6a4c.png";